import {default as VtxImage} from './VtxImage';
import {default as VtxImageViewer} from './VtxImageViewer';

VtxImage.VtxImageViewer = VtxImageViewer;

export default VtxImage;
export {VtxImage,VtxImageViewer};